import { forwardRef } from "react";

import { Typography } from "@mui/material";

import { sectionTitleStyles } from "./SectionTitle.styles";


export const SectionTitle = forwardRef((props, ref) => {
  const classes = sectionTitleStyles();
  
  const handleMenuClick = (e) => {
    e.stopPropagation();
    console.log("MENU button clicked");
    // Use the same behavior as the title text
    if (props.onClickPrevButton) {
      console.log("Calling onClickPrevButton");
      props.onClickPrevButton();
    } else {
      console.log("onClickPrevButton not available");
    }
  };
  
  return (
    <div ref={ref} className={classes.section_title__root}>
      {props.showMenuButton && (
        <button 
          className={classes.section_title__menu_button}
          onClick={handleMenuClick}
          type="button"
        >
          MENU
        </button>
      )}
      <Typography variant="caption" className={classes.section_title__text} onClick={props.onClickPrevButton}>
        {props.children}
      </Typography>
    </div>
  );
});
